export default "__VITE_ASSET__qcK9$NnZ__"